import { render, staticRenderFns } from "./BaseToolbarWrapper.vue?vue&type=template&id=5a37db2c"
import script from "./BaseToolbarWrapper.vue?vue&type=script&lang=ts"
export * from "./BaseToolbarWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports